import React from 'react';
import { IMDFCircleIconSize, MDFCircleIcon } from '../MDFCirlceIcon';
import classNames from 'classnames';
import { WFNXTitleBar } from './WFNXTitleBar';
import { MDFIcon } from '../MDFIcon';

export interface IWFNXTitleBarProps {
  children?: React.ReactNode;
  className?: string;
  iconSize?: IMDFCircleIconSize;
  title?: React.ReactNode;
  titleBarIcon?: string;
}

export class WFNXIconTitleBar extends React.Component<IWFNXTitleBarProps, any> {
  render() {
    const { className, children, iconSize, title, titleBarIcon } = this.props;

    return (
      <div className={classNames(`wfnx-icon-titleBar-wrapper ${className}`)}>
        <WFNXTitleBar>
          <MDFCircleIcon size={iconSize || 'sm'} className={`titleBar-circle titleBar-circle--${iconSize}`}>
            <MDFIcon className={`${titleBarIcon} titleBar-icon-color`}></MDFIcon>
          </MDFCircleIcon>
          <div className="title"> {title}</div>
          {children}
        </WFNXTitleBar>
      </div>
    );
  }
}
